var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"suaw-section",class:[
    'suaw-section--' + _vm.sectionStyle,
    'suaw-section--' + _vm.sectionSize
  ]},[_vm._l((_vm.sectionItems),function(item,index){return _c(item.component,_vm._b({key:index,tag:"component"},'component',item.props,false))}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }